import { action, computed, makeObservable, observable } from 'mobx';
import moment from 'moment';
import { dateFormatForRequest } from '~/constants/dateTime';
import client from '~/services/client';
import logger from '~/services/logger';
import { TPagination, paginationCast } from '~/types/main';
import { PromocodeLog } from '~/view/screens/PromocodeLogScreen/types';
import { BaseStore } from '~/view/screens/SettingsScreen/store/BaseStore';

const defaultPagination = {
  currentPage: 0,
  lastPage: 0,
  perPage: 0,
  totalRows: 0,
};

const defaultFilters = {
  startDate: moment().subtract(3, 'months').unix() * 1000,
  endDate: moment().unix() * 1000,
};

class PromocodeLogStore extends BaseStore {
  constructor() {
    super();
    makeObservable(this);
  }

  @observable public pagination: TPagination = defaultPagination;
  @observable public promocodeLogList: PromocodeLog[] = [];
  @observable public filters = defaultFilters;
  @observable public loading = false;

  @action setFilters = (filters: typeof defaultFilters) => {
    this.filters = filters;
    this.fetchPromocodeLogList();
  };

  @action fetchPromocodeLogList = async (page = 1) => {
    try {
      this.loading = true;

      const response = await client.get('v3/promocodes/usage-log', {
        params: { ...this.paramsForLogsRequest, page },
      });

      this.pagination = paginationCast(response.data.pagination);
      this.promocodeLogList = response.data.promocodes;
    } catch (error) {
      logger.error({ error, place: 'promocodeLogStore fetchPromocodeLogList' });
    } finally {
      this.loading = false;
    }
  };

  @computed get isDataNotPresented() {
    return !this.loading && this.promocodeLogList.length === 0;
  }

  @computed get paramsForLogsRequest() {
    return {
      page: this.pagination.currentPage,
      filters: {
        date_start: moment(this.filters.startDate).format(dateFormatForRequest),
        date_end: moment(this.filters.endDate).format(dateFormatForRequest),
      },
    };
  }
}

export const promocodeLogStore = new PromocodeLogStore();
